<template>
  <div class="media-collection__item">
    <media-image :image="mediaItem"/>
    <div class="media-collection__actions">
      <el-button
        @click.prevent="attach"
        v-if="(productId !== undefined) && supportedFeaturesOutbox"
        type="text"
        :class="{active: isAttached}"
        icon="el-icon-custom-clip-board">
        <!--TODO 'Attach File'-->
        {{ $t('mediaCollectionAttachmentLabel') }}
      </el-button>
    </div>
  </div>
</template>

<script>
  import user from './user';
  import MediaImage from '@/components/media/MediaImage';
  import outbox from '@/components/outbox';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import mixins from '@/mixins';

  export default {
    name: 'MediaCollectionItem',
    mixins: [
      mixins.supportedFeatures
    ],
    props: {
      productId: {},
      mediaItem: {}
    },
    computed: {
      ...mapState(outbox.store.namespace, [
        'assets'
      ]),
      ...mapGetters(user.store.namespace, [
        'region'
      ]),
      isAttached
    },
    methods: {
      ...mapActions(outbox.store.namespace, [
        'attachItemForProduct'
      ]),
      attach(){ this.attachItemForProduct({productId: this.productId, assetId: this.mediaItem.id}); }
    },
    components: {
      MediaImage,
    }
  }

  //////////

  function isAttached() {
    let selection = this.assets; // keep this to have Vue watch selected assets for changes.
    return this.$store.getters[`${outbox.store.namespace}/assetIsAttached`](this.productId, this.mediaItem.id);
  }
</script>

<style lang="scss" scoped>

  .media-collection__item {
    margin: 20px 0;
  }

  .media-collection__actions {
    width: 100%;

    button {
      text-transform: uppercase;
      color: #666;
    }
  }

  .el-button {
    &.active {
      color: #ED1C2E;
    }
  }
</style>
